var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.kioskMenuPage },
    [
      _c("div", { class: _vm.$style.kioskMenuMain }, [
        _c("div", { class: _vm.$style.kioskMenuHeader }, [
          _c(
            "div",
            {
              class: _vm.$style.menuHeaderArrow,
              on: { click: _vm.handleStartOver }
            },
            [
              _c("svg", {
                directives: [{ name: "svg", rawName: "v-svg" }],
                class: _vm.$style.curvedArrowUp,
                attrs: { symbol: "kiosk-curved-arrow" }
              }),
              _vm._v(" "),
              _c("h5", { class: _vm.$style.menuHeaderTitle }, [
                _vm._v("Start Over")
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { class: _vm.$style.menuHeaderArrow }, [
            _c("svg", {
              directives: [{ name: "svg", rawName: "v-svg" }],
              class: _vm.$style.curvedArrowUp,
              attrs: { symbol: "kiosk-curved-arrow" }
            }),
            _vm._v(" "),
            _c("h5", { class: _vm.$style.menuHeaderTitle }, [
              _vm._v("View your order")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.$style.kioskMenuWrapper },
          [_c("DesktopMenu")],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$style.kioskMenuFooter },
        [_c("KioskTryBlock")],
        1
      ),
      _vm._v(" "),
      _vm.menuIsLoading
        ? _c("LoadingSpinner", { attrs: { fixed: "" } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/kiosk/components/KioskMenu.vue?vue&type=template&id=ff0a092e&
// module id = null
// module chunks = 